// extracted by mini-css-extract-plugin
module.exports = {"bxTextTruncateEnd":"Grid-module--bx--text-truncate--end--3xB7V","bxTextTruncateFront":"Grid-module--bx--text-truncate--front--1AH5R","column":"Grid-module--column--1TDtT"};